import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResourceService } from './resource.service';
import { CustomEvent } from '@model';

@Injectable()
export class CustomEventService {
  constructor(
    private customEventResourceService: ResourceService<CustomEvent>,
  ) {}

  getCustomEvents$(scenarioId: string): Observable<CustomEvent[]> {
    return this.customEventResourceService.getList(
      `scenarios/${scenarioId}/custom-events`,
    );
  }

  deleteCustomEvents$(id: string): Observable<CustomEvent> {
    return this.customEventResourceService.delete(`custom-events`, id);
  }
}
